import React from "react"
import { connect } from "react-redux"
import qs from "query-string"
import { ButtonLink, Button } from "buoy-core"

import Text from "../../common/components/Text"
import Container from "../../common/components/Container"
import tracker from "../../common/tracker"

import * as actions from "../actions"
import AuthForm from "./AuthForm"
import PageWrapper from "./PageWrapper"

const Login = props => (
  <AuthForm
    title="Welcome Back!"
    submitText="Log in"
    showEmail
    showPass
    {...props}
  >
    <Container marginBottom="24px">
      <ButtonLink fontSize="bodySmall" onClick={props.onResetClick}>
        Forgot password?
      </ButtonLink>
    </Container>
    <Container marginBottom="0.667rem">
      <Text size="bodyMain">New to Buoy?</Text>
    </Container>
    <Button color="neutral" onClick={props.onSignupClick}>
      Create account
    </Button>
  </AuthForm>
)

const LoginWrapper = PageWrapper(Login)

class LoginPage extends React.Component {
  componentDidMount() {
    let url_query = qs.parse(window.location.search)

    // If the url has is_active set to 0, that means the user has not activated
    // their account yet
    if (url_query.is_active === "0") {
      this.props.setLoginStatus({
        status: "bad",
        msg:
          "Looks like you " +
          "haven't clicked on your activation link yet. No worries, we just " +
          "emailed you a new link. Please check it now.",
      })
    }

    // This means that the page loaded with an message
    if (url_query.already_registered === "1") {
      this.props.setLoginStatus({
        status: "bad",
        msg:
          "Looks like you already " +
          "have an active account. Just type in your password to get started.",
      })
    }

    tracker.loginLoaded()

    if (url_query.msg)
      this.props.setLoginStatus({
        status: url_query.status,
        msg: url_query.msg,
      })
  }

  render() {
    return <LoginWrapper {...this.props} onSubmit={this.props.submit} />
  }
}

const mapStateToProps = state => ({
  email: state.auth.email,
  authError: state.auth.status.login,
})

const mapDispatchToProps = (dispatch, ownProps) => ({
  onSignupClick: () => (window.location = "/signup"),
  onResetClick: () => (window.location = "/reset"),
  onEmailChange: email => dispatch(actions.setEmail(email)),
  submit: password => {
    if (ownProps.dashboard) {
      ownProps.onSubmit(password)
    } else {
      let { redirect, next } = qs.parse(window.location.search)
      dispatch(actions.loginSubmit(password, redirect || next))
    }
  },
})

const LoginPageWrapper = connect(mapStateToProps, mapDispatchToProps)(LoginPage)

export { LoginPageWrapper as default, LoginPage, Login }



// WEBPACK FOOTER //
// ./assets/auth/components/LoginPage.js